<template>
  <div>
    <VTableRemote
      ref="tableRemoteRef"
      class="billingCustomTable"
      :items="allSitesDetails"
      hideDefaultFooter
      :headers="tableHeaders"
      :pagination="pagination"
      :centerColumns="['linkedUsers', 'linkedDevices', 'billable']"
      isCustomIcon
      :isSearchable="false"
      :loading="isFetching"
      :isInfinitScroll="true"
      @sendQueryParams="fetchQuery()"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-start">
            {{ item.clientNumber }}
          </td>
          <td class="text-start">
            {{ item.clientName }}
          </td>
          <td class="text-start">
            {{ item.siteNumber }}
          </td>
          <td class="text-start">
            {{ item.siteName }}
          </td>
          <td class="text-center">
            {{ item.linkedUsers }}
          </td>
          <td class="text-center">
            {{ item.linkedDevices }}
          </td>
        </tr>
      </template>
      <template #withInfiniteScroll>
        <div v-intersect="endIntersect" />
      </template>
    </VTableRemote>
  </div>
</template>

<script>

import VTableRemote from '@/components/shared/content-views/VTableRemote.vue';
import perpage from '@/constants/pagination';

export default {
    name: 'SiteDetails',
    components: { VTableRemote },
    props: {
        teamId: String,
        default: () => '',
    },
    data() {
        return {
            isFetching: false,
            allSitesDetails: [],
            pagination: {},
            queryParams: { perpage, page: 1 },
        };
    },
    computed: {
        tableHeaders() {
            return [
                {
                    text: this.$t('billing.labels.clientNumber'),
                    value: 'clientNumber',
                },
                {
                    text: this.$t('forms.labels.clientName'),
                    value: 'clientName',
                    width: 150,
                },
                {
                    text: this.$t('forms.labels.siteNumber'),
                    value: 'siteNumber',
                },
                {
                    text: this.$t('forms.labels.siteName'),
                    value: 'siteName',
                    width: 150,
                },
                {
                    text: this.$t('aquassistBilling.billingRegister.labels.linkedUsers'),
                    value: 'linkedUsers',
                },
                {
                    text: this.$t('aquassistBilling.billingRegister.labels.linkedDevices'),
                    value: 'linkedDevices',
                },
            ];
        },
    },
    async created() {
        await this.getAllSitesDetails();
    },
    methods: {
        async fetchQuery(queryParams) {
            this.queryParams = { ...this.queryParams, ...queryParams, page: 1 };
            this.pagination = {};
            this.allSitesDetails = [];
            await this.getAllSitesDetails();
        },
        async getAllSitesDetails() {
            this.isFetching = true;
            const cleanQueryParams = this.$utils.removeEmptyNullOrUndefined({ ...this.queryParams }, true);
            const { data } = await this.$rq.getCurrentBillingDetails('sitesDetails', this.teamId, cleanQueryParams);
            this.allSitesDetails = [...this.allSitesDetails, ...data.sitesDetails];
            this.pagination = data.pagination;
            this.isFetching = false;
        },
        async endIntersect(_, __, isIntersecting) {
            const condition = this.pagination.currentPage < this.pagination.totalPageCount;
            if (isIntersecting && condition && !this.isFetching) {
                this.queryParams.page = this.pagination.currentPage + 1;
                await this.getAllSitesDetails();
                const ref = this.$refs?.tableRemoteRef?.$refs?.tableRemote;
                if (ref?.onScroll) {
                    ref.onScroll();
                }
            }
        },
    },
};

</script>

<style lang="scss" scoped>
@import "@/assets/styles/pricingManagement.scss";
.billingCustomTable{
    ::v-deep table{
        padding:0 5px 0 0;
    }
    ::v-deep .blocHeader {
        height: 0;
    }
    ::v-deep .v-data-table__wrapper{
        height: 420px !important;
    }
}
</style>
